//@ts-ignore
import styled from "styled-components";
import { Player } from "@lottiefiles/react-lottie-player";

import animationData from "components/report/@json/loading.json";

export const PartialCircleLoading = ({
  width = 40,
  className,
}: {
  width?: number;
  top?: number;
  className?: string;
}) => (
  <Loading width={width} className={className}>
    <Player
      loop
      autoplay
      src={animationData}
      style={{ width: `${width}px`, position: "relative" }}
      rendererSettings={{
        preserveAspectRatio: "xMidYMid slice",
      }}
    />
  </Loading>
);

const Loading = styled.div<{ width: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
